import * as Yup from 'yup';

const headers = [
  {
    label: 'Name',
    id: 'full_name'
  },
  {
    label: 'Email',
    id: 'email'
  },
  {
    label: 'Phone',
    id: 'mobile_phone'
  },
  {
    label: "Active",
    id: "is_active",
    boolean: true,
    values: ["Active", "Inactive"]
  }
];

const filters = [
  {
    id: "is_active",
    type: "boolean",
    label: "Active",
  }
]

const fields = [
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "first_name",
    label: "First Name",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "last_name",
    label: "Last Name",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "email",
    label: "Email",
    type: "email",
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "mobile_phone",
    label: "Mobile Phone",
    type: "phone",
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: "divider",
    header: "Login Access",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "select",
    options: [],
    name: "user_id",
    label: "Select User",
    defaultValue: "",
    type: "text",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "divider",
    header: "Account Details",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "notes",
    label: "Notes",
    type: "text",
    multiline: true,
    rows: 4,
    size: {xs: 12, lg: 8},
  },
  {
    fieldType: "formField",
    formFieldType: "switch",
    name: "is_active",
    label: "Active",
    type: "checkbox",
    size: {xs: 12, lg: 4},
  }
]

const initialValues = {
  
  first_name: '',
  last_name: '',
  email: '',
  mobile_phone: '',
  is_active: true
}

const schema = Yup.object().shape({
  first_name: Yup.string().required('First Name is required'),
  last_name: Yup.string().required('Last Name is required'),
  email: Yup.string().email('Invalid email address'),
  mobile_phone: Yup.string().optional().min(7).max(15),
  is_active: Yup.boolean()
});

export { headers, filters, fields, schema, initialValues };